// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shared-app[data-v-0c15c3be] {\n  height: 100vh;\n  width: 100vw;\n}\n", "",{"version":3,"sources":["webpack://./public/SharedApp.vue","webpack://./SharedApp.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,YAAA;ACAF","sourcesContent":["\n.shared-app {\n  height: 100vh;\n  width: 100vw;\n}\n",".shared-app {\n  height: 100vh;\n  width: 100vw;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
